module.exports = __webpack_public_path__ + "img/29.2fd9f69f.jpg";